export function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ")
}

export function lighten(color: string) {
    return color
}
